var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrongPasswordAttemptsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wrong_Password_attempts_32px",
    "data-name": "Wrong Password attempts_32px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 32,
    height: 32,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 26,
    height: 26,
    transform: "translate(3 3)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2266",
    "data-name": "Group 2266",
    transform: "translate(-157.283 -87.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M15.069,10.81H5.4A5.4,5.4,0,0,1,5.4,0H17.045c.122,0,.247,0,.37.013H15.3a2,2,0,0,0-2,2V8.822a2,2,0,0,0,1.765,1.986ZM9.388,6.225a.043.043,0,0,1,.023.006.049.049,0,0,1,.023.04V7.277a.375.375,0,0,0,.374.374h.374a.375.375,0,0,0,.374-.374V6.272a.046.046,0,0,1,.023-.04.042.042,0,0,1,.047,0l.87.5a.359.359,0,0,0,.183.049.379.379,0,0,0,.1-.013A.365.365,0,0,0,12,6.6l.192-.335a.357.357,0,0,0,.037-.279.366.366,0,0,0-.172-.224l-.872-.506a.047.047,0,0,1-.023-.04.049.049,0,0,1,.023-.041l.872-.506a.369.369,0,0,0,.137-.5L12,3.831a.368.368,0,0,0-.5-.134l-.87.5a.053.053,0,0,1-.047,0,.051.051,0,0,1-.023-.041v-1a.375.375,0,0,0-.374-.375H9.809a.375.375,0,0,0-.374.375v1a.047.047,0,0,1-.023.04.047.047,0,0,1-.047,0L8.5,3.7a.36.36,0,0,0-.185-.05.375.375,0,0,0-.094.013.36.36,0,0,0-.225.173L7.8,4.167a.364.364,0,0,0-.037.28.373.373,0,0,0,.172.224l.872.506a.046.046,0,0,1,.023.04.049.049,0,0,1-.023.041l-.873.506a.369.369,0,0,0-.135.5l.194.337a.371.371,0,0,0,.319.184.366.366,0,0,0,.184-.049l.87-.5A.043.043,0,0,1,9.388,6.225Zm-5.82,0a.053.053,0,0,1,.023.005.046.046,0,0,1,.023.04v1a.375.375,0,0,0,.375.374h.374a.375.375,0,0,0,.374-.374V6.271a.049.049,0,0,1,.023-.041.053.053,0,0,1,.047,0l.869.5a.368.368,0,0,0,.184.05.381.381,0,0,0,.095-.013A.362.362,0,0,0,6.181,6.6l.193-.334a.359.359,0,0,0,.037-.28.366.366,0,0,0-.172-.223l-.872-.506a.047.047,0,0,1-.023-.04.046.046,0,0,1,.023-.041l.872-.506a.369.369,0,0,0,.136-.5l-.194-.337a.368.368,0,0,0-.5-.135l-.87.5a.042.042,0,0,1-.047,0,.047.047,0,0,1-.023-.041v-1a.375.375,0,0,0-.374-.374H3.989a.375.375,0,0,0-.375.374v1a.047.047,0,0,1-.047.047A.051.051,0,0,1,3.544,4.2l-.869-.5a.368.368,0,0,0-.185-.049A.355.355,0,0,0,2.4,3.66a.37.37,0,0,0-.226.173l-.192.334a.368.368,0,0,0,.135.5l.872.506a.049.049,0,0,1,.023.041.047.047,0,0,1-.023.041l-.873.507a.372.372,0,0,0-.135.5l.194.337a.371.371,0,0,0,.319.184.366.366,0,0,0,.184-.049l.87-.5A.052.052,0,0,1,3.568,6.226Z",
    transform: "translate(160 100.645)",
    fill: "#3e5172"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139",
    transform: "translate(173.304 93.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock-closed-outline",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M182.236,39.652V36.041a3.119,3.119,0,0,0-6.236,0v3.611",
    transform: "translate(-172.882 -33)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_747",
    "data-name": "Rectangle 747",
    width: 12.472,
    height: 10.809,
    rx: 2,
    transform: "translate(0 6.699)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M124.173,123.331l2.355-2.355a.6.6,0,1,0-.841-.843l-2.355,2.355-2.355-2.355a.6.6,0,1,0-.843.843l2.355,2.355-2.355,2.355a.6.6,0,0,0,.843.843l2.355-2.355,2.355,2.355a.6.6,0,0,0,.843-.843Z",
    transform: "translate(-117.095 -110.894)",
    fill: "#3e5172"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongPasswordAttemptsIcon);
export default __webpack_public_path__ + "static/media/wrong-password-attempts-icon.f20c3d0d190223a12e16f61c3995a0ff.svg";
export { ForwardRef as ReactComponent };